import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MobileMenuItem } from '../../../../shared/interfaces/mobile-menu-item';
import { FiberService } from 'src/app/services/fiber.service';
import { Router } from '@angular/router';
import { UserSessionService } from 'src/app/services/usersession.service';

@Component({
    selector: 'app-mobile-links',
    templateUrl: './mobile-links.component.html',
    styleUrls: ['./mobile-links.component.scss'],
})
export class MobileLinksComponent {
    @Input() links: MobileMenuItem[] = [];
    @Input() level = 0;
    public menuItems: any;
    selectedSubMenuId: number;
    currentUrl: any;
    isLoggedIn: boolean = false;

    @Output() itemClick: EventEmitter<MobileMenuItem> = new EventEmitter();

    constructor(
        private router: Router,
        private userSessionService: UserSessionService
    ) {
        const menu = this.userSessionService.getLocalStorageWithKey('menu');
        if (menu) {
      this.menuItems = JSON.parse(menu);

        }
    }

    ngOnInit(): void {
        this.isLoggedIn =
            localStorage.getItem('isLoggedIn') === 'true' ? true : false;
        this.currentUrl = window.location.pathname.replace('/', '');
    }

    onItemClick(item: MobileMenuItem): void {
        this.itemClick.emit(item);

    }

    menuAction(menu) {
        if (menu.id === 114) {
            if (this.selectedSubMenuId) this.selectedSubMenuId = undefined;
            else this.selectedSubMenuId = menu.id;
        } else {
            if (menu.pageURL !== '#') {
                this.router.navigate(['/' + menu.pageURL]);
                this.currentUrl = menu.pageURL;
            }
        }
    }
}
